export const JSON_RPC_URL = 'https://cloudflare-eth.com'
